function cov_1hcd01bec() {
  var path = "/codebuild/output/src315236701/src/src/common/components/CanvasSvg.vue";
  var hash = "19c6c0b2cdbd326fad58635617f3610cabfe34e6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src315236701/src/src/common/components/CanvasSvg.vue",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 19
        },
        end: {
          line: 3,
          column: 30
        }
      },
      "1": {
        start: {
          line: 4,
          column: 19
        },
        end: {
          line: 10,
          column: 1
        }
      },
      "2": {
        start: {
          line: 11,
          column: 33
        },
        end: {
          line: 11,
          column: 463
        }
      },
      "3": {
        start: {
          line: 12,
          column: 19
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "4": {
        start: {
          line: 21,
          column: 33
        },
        end: {
          line: 21,
          column: 99
        }
      },
      "5": {
        start: {
          line: 22,
          column: 33
        },
        end: {
          line: 25,
          column: 12
        }
      },
      "6": {
        start: {
          line: 26,
          column: 33
        },
        end: {
          line: 29,
          column: 12
        }
      },
      "7": {
        start: {
          line: 30,
          column: 19
        },
        end: {
          line: 34,
          column: 1
        }
      },
      "8": {
        start: {
          line: 35,
          column: 33
        },
        end: {
          line: 42,
          column: 6
        }
      },
      "9": {
        start: {
          line: 54,
          column: 8
        },
        end: {
          line: 71,
          column: 10
        }
      },
      "10": {
        start: {
          line: 55,
          column: 12
        },
        end: {
          line: 70,
          column: 32
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        loc: {
          start: {
            line: 52,
            column: 19
          },
          end: {
            line: 72,
            column: 5
          }
        },
        line: 52
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 54,
            column: 15
          },
          end: {
            line: 54,
            column: 16
          }
        },
        loc: {
          start: {
            line: 54,
            column: 33
          },
          end: {
            line: 71,
            column: 9
          }
        },
        line: 54
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 57,
            column: 25
          },
          end: {
            line: 57,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 57,
            column: 42
          },
          end: {
            line: 57,
            column: 59
          }
        }, {
          start: {
            line: 57,
            column: 62
          },
          end: {
            line: 57,
            column: 74
          }
        }],
        line: 57
      },
      "1": {
        loc: {
          start: {
            line: 60,
            column: 16
          },
          end: {
            line: 62,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 61,
            column: 23
          },
          end: {
            line: 61,
            column: 76
          }
        }, {
          start: {
            line: 62,
            column: 22
          },
          end: {
            line: 62,
            column: 51
          }
        }],
        line: 60
      },
      "2": {
        loc: {
          start: {
            line: 65,
            column: 20
          },
          end: {
            line: 67,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 66,
            column: 27
          },
          end: {
            line: 66,
            column: 102
          }
        }, {
          start: {
            line: 67,
            column: 26
          },
          end: {
            line: 67,
            column: 55
          }
        }],
        line: 65
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/codebuild/output/src315236701/src/src/common/components/CanvasSvg.vue.ts",
      sourceRoot: "",
      sources: ["/codebuild/output/src315236701/src/node_modules/vue-cli-plugin-quasar/lib/loader.js.transform-quasar-imports.js!/codebuild/output/src315236701/src/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!/codebuild/output/src315236701/src/node_modules/vue-cli-plugin-quasar/lib/loader.vue.auto-import-quasar.js??ruleSet[0].use[1]!/codebuild/output/src315236701/src/src/common/components/CanvasSvg.vue?vue&type=script&setup=true&lang=ts"],
      names: [],
      mappings: "AAAA,OAAO,EAAE,eAAe,IAAI,gBAAgB,EAAE,MAAM,KAAK,CAAA;AACzD,OAAO,EAAE,SAAS,IAAI,UAAU,EAAE,kBAAkB,IAAI,mBAAmB,EAAE,kBAAkB,IAAI,mBAAmB,EAAE,kBAAkB,IAAI,mBAAmB,EAAE,cAAc,IAAI,eAAe,EAAE,iBAAiB,IAAI,kBAAkB,EAAE,MAAM,KAAK,CAAA;AAE1P,MAAM,UAAU,GAAG,CAAC,SAAS,CAAC,CAAA;AAC9B,MAAM,UAAU,GAAG;IACjB,GAAG,EAAE,CAAC;IACN,WAAW,EAAE,SAAS;IACtB,WAAW,EAAE,SAAS;IACtB,CAAC,EAAE,ugHAAugH;IAC1gH,IAAI,EAAE,gBAAgB;CACvB,CAAA;AACD,MAAM,UAAU,GAAG,aAAa,CAAA,kBAAkB,CAAC,uZAAuZ,EAAE,CAAC,CAAC,CAAA;AAC9c,MAAM,UAAU,GAAG;IACjB,GAAG,EAAE,CAAC;IACN,EAAE,EAAE,UAAU;IACd,EAAE,EAAE,UAAU;IACd,EAAE,EAAE,SAAS;IACb,EAAE,EAAE,SAAS;IACb,EAAE,EAAE,SAAS;IACb,aAAa,EAAE,gBAAgB;CAChC,CAAA;AACD,MAAM,UAAU,GAAG,aAAa,CAAA,mBAAmB,CAAC,MAAM,EAAE,EAAE,YAAY,EAAE,SAAS,EAAE,EAAE,IAAI,EAAE,CAAC,CAAC,CAAC,CAAA;AAClG,MAAM,UAAU,GAAG,aAAa,CAAA,mBAAmB,CAAC,MAAM,EAAE;IAC1D,MAAM,EAAE,UAAU;IAClB,YAAY,EAAE,SAAS;CACxB,EAAE,IAAI,EAAE,CAAC,CAAC,CAAC,CAAA;AACZ,MAAM,UAAU,GAAG,aAAa,CAAA,mBAAmB,CAAC,MAAM,EAAE;IAC1D,MAAM,EAAE,GAAG;IACX,YAAY,EAAE,SAAS;CACxB,EAAE,IAAI,EAAE,CAAC,CAAC,CAAC,CAAA;AACZ,MAAM,UAAU,GAAG;IACjB,UAAU;IACV,UAAU;IACV,UAAU;CACX,CAAA;AACD,MAAM,UAAU,GAAG,aAAa,CAAA,mBAAmB,CAAC,UAAU,EAAE,EAAE,EAAE,EAAE,QAAQ,EAAE,EAAE;IAChF,aAAa,CAAA,mBAAmB,CAAC,MAAM,EAAE;QACvC,KAAK,EAAE,IAAI;QACX,MAAM,EAAE,IAAI;QACZ,IAAI,EAAE,OAAO;QACb,SAAS,EAAE,oBAAoB;KAChC,CAAC;CACH,EAAE,CAAC,CAAC,CAAC,CAAA;AAGN,eAAe,aAAa,CAAA,gBAAgB,CAAC;IAC3C,MAAM,EAAE,WAAW;IACnB,KAAK,EAAE;QACP,MAAM,EAAE;YACN,IAAI,EAAE,OAAO;YACb,QAAQ,EAAE,KAAK;YACf,OAAO,EAAE,KAAK;SACf;KACF;IACC,KAAK,CAAC,OAAO;QAEf,4BAA4B;QAG5B,OAAO,CAAC,IAAS,EAAC,MAAW,EAAE,EAAE;YAC/B,OAAO,CAAC,UAAU,EAAE,EAAE,mBAAmB,CAAC,KAAK,EAAE;gBAC/C,KAAK,EAAE,4BAA4B;gBACnC,OAAO,EAAE,OAAO,CAAC,MAAM,CAAC,CAAC,CAAC,iBAAiB,CAAC,CAAC,CAAC,YAAY;gBAC1D,KAAK,EAAE,eAAe,CAAC,EAAE,UAAU,EAAE,OAAO,CAAC,MAAM,EAAC,UAAU,EAAG,CAAC,OAAO,CAAC,MAAM,EAAE,CAAC;aACpF,EAAE;gBACD,CAAC,CAAC,OAAO,CAAC,MAAM,CAAC;oBACf,CAAC,CAAC,CAAC,UAAU,EAAE,EAAE,mBAAmB,CAAC,MAAM,EAAE,UAAU,CAAC,CAAC;oBACzD,CAAC,CAAC,mBAAmB,CAAC,EAAE,EAAE,IAAI,CAAC;gBACjC,UAAU;gBACV,mBAAmB,CAAC,MAAM,EAAE,IAAI,EAAE;oBAChC,CAAC,CAAC,OAAO,CAAC,MAAM,CAAC;wBACf,CAAC,CAAC,CAAC,UAAU,EAAE,EAAE,mBAAmB,CAAC,gBAAgB,EAAE,UAAU,EAAE,UAAU,CAAC,CAAC;wBAC/E,CAAC,CAAC,mBAAmB,CAAC,EAAE,EAAE,IAAI,CAAC;oBACjC,UAAU;iBACX,CAAC;aACH,EAAE,EAAE,EAAE,UAAU,CAAC,CAAC,CAAA;QACrB,CAAC,CAAA;IACD,CAAC;CAEA,CAAC,CAAA",
      sourcesContent: ["import { defineComponent as _defineComponent } from 'vue'\nimport { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from \"vue\"\n\nconst _hoisted_1 = [\"viewBox\"]\nconst _hoisted_2 = {\n  key: 0,\n  \"fill-rule\": \"evenodd\",\n  \"clip-rule\": \"evenodd\",\n  d: \"M24.8222 20.1125C18.5075 23.3241 13.0416 27.9634 8.86501 33.6565L9.08508 33.3834C3.19544 41.2883 0.0134803 50.8585 0.00601086 60.6899C-0.102668 66.2234 1.26408 71.6871 3.96781 76.5276C6.48512 81.1552 10.3103 84.9517 14.9728 87.4502C20.0829 90.0247 25.7503 91.3185 31.4802 91.2185C39.6259 91.2697 47.6261 89.0767 54.5906 84.8834C61.6895 80.6791 67.4199 74.5366 71.0981 67.1888H53.5452C51.3499 70.4579 48.3598 73.1251 44.8512 74.9438C41.4485 76.6892 37.6765 77.6064 33.8463 77.6199C31.3636 77.7466 28.8813 77.3661 26.5529 76.5018C24.2245 75.6376 22.0998 74.308 20.3102 72.5955C18.6005 70.7772 17.2763 68.6365 16.4162 66.3005C15.556 63.9645 15.1774 61.4808 15.3029 58.9969C15.3655 57.1664 15.5494 55.3421 15.8532 53.5356C16.6123 48.9687 18.3376 44.6133 20.9155 40.7562C23.3529 37.2185 26.5951 34.2999 30.3797 32.2366C34.1255 30.2715 38.3035 29.2583 42.5402 29.2875C46.1519 29.1685 49.7224 30.0781 52.8298 31.9089C55.6078 33.6244 57.6914 36.2528 58.7175 39.3362H75.9403C75.529 35.8788 74.4264 32.5377 72.6973 29.5087C70.9682 26.4796 68.6474 23.8236 65.8708 21.6963C59.8501 17.2815 52.4966 15.0284 45.0163 15.3066C37.9921 15.2614 31.062 16.9107 24.8222 20.1125ZM131.045 76.7723H160.833L163.082 91.2239H178.882L165.331 15.2836H147.996L108.004 91.2239H123.694L131.045 76.7723ZM153.427 32.7482L158.913 64.8875H136.969L153.427 32.7482ZM285.475 91.2239H270.259L245.416 39.2207L236.231 91.2239H221.071L234.405 15.2836H249.51L274.464 67.4542L283.649 15.2836H298.699L285.475 91.2239ZM366.862 75.6893L356.965 15.2836H340.888L355.051 91.2239H373.151L413.453 15.2836H397.594L366.862 75.6893ZM489.881 76.7723H460.139L452.744 91.2239H437.079L477.064 15.2836H494.427L507.956 91.2239H492.181L489.881 76.7723ZM487.964 64.8875L482.486 32.7482L466.054 64.8875H487.964ZM551.951 80.0498C553.219 82.5335 555.107 84.6578 557.437 86.2223C562.956 89.7512 569.456 91.4885 576.025 91.1912C581.153 91.3069 586.246 90.3388 590.963 88.3518C594.941 86.7178 598.373 84.0119 600.866 80.5436C603.195 77.2073 604.414 73.2375 604.351 69.1862C604.476 65.6664 603.447 62.2007 601.419 59.3031C599.496 56.6071 597.005 54.3533 594.116 52.6961C590.759 50.7263 587.265 48.9929 583.66 47.5088C580.451 45.9799 577.962 44.7787 576.247 43.7958C574.602 42.9268 573.122 41.7812 571.876 40.4104C570.717 39.1372 570.086 37.4806 570.106 35.7692C570.061 34.5443 570.32 33.3273 570.86 32.2236C571.4 31.1198 572.205 30.1627 573.204 29.4352C575.59 27.7703 578.473 26.9435 581.392 27.0873C584.056 26.9267 586.688 27.7218 588.805 29.326C589.646 30.0286 590.316 30.9086 590.766 31.9009C591.216 32.8932 591.434 33.9725 591.405 35.0593V36.206H607.449C607.792 32.3987 606.922 28.5808 604.96 25.2854C602.868 21.9706 599.771 19.3911 596.108 17.914C591.741 16.074 587.024 15.1803 582.277 15.2931C577.337 15.2078 572.434 16.1569 567.893 18.0778C563.895 19.7058 560.457 22.4355 557.99 25.9406C555.536 29.4492 554.277 33.6371 554.394 37.8987C554.247 41.4564 555.234 44.97 557.215 47.9456C559.012 50.5121 561.377 52.6409 564.131 54.1704C567.526 56.0262 571.037 57.6675 574.642 59.0846C578.241 60.4662 581.689 62.2042 584.933 64.2719C585.958 64.9727 586.793 65.9124 587.362 67.0078C587.931 68.1032 588.218 69.3203 588.197 70.5513C588.262 71.8158 588.008 73.0765 587.458 74.2201C586.907 75.3638 586.078 76.3546 585.043 77.1036C582.466 78.7539 579.425 79.5567 576.357 79.3969C574.838 79.5082 573.312 79.3086 571.874 78.8106C570.437 78.3126 569.119 77.527 568.004 76.503C567.065 75.5434 566.359 74.3868 565.937 73.1198C565.516 71.8527 565.39 70.508 565.569 69.1862H550.189C550.131 70.1318 550.131 71.08 550.189 72.0256C550.077 74.8046 550.683 77.566 551.951 80.0498Z\",\n  fill: \"url(#canvas-c)\"\n}\nconst _hoisted_3 = /*#__PURE__*/_createStaticVNode(\"<g clip-path=\\\"url(#canvas)\\\"><path d=\\\"M667.927 77.625H649.552V96H667.927V77.625Z\\\" fill=\\\"#4492D3\\\"></path><path d=\\\"M745.552 0H727.177V18.375H745.552V0Z\\\" fill=\\\"#4492D3\\\"></path><path d=\\\"M745.552 18.375H727.177V77.625H667.927V96H745.552V18.375Z\\\" fill=\\\"#06CAB8\\\"></path><path d=\\\"M667.927 77.625H649.552V38.8125L688.365 0H727.177V18.375H695.865L667.927 46.3125V77.625Z\\\" fill=\\\"#9249F5\\\"></path></g>\", 1)\nconst _hoisted_4 = {\n  key: 0,\n  id: \"canvas-c\",\n  x1: \"-4.20925\",\n  y1: \"53.2967\",\n  x2: \"607.726\",\n  y2: \"53.2967\",\n  gradientUnits: \"userSpaceOnUse\"\n}\nconst _hoisted_5 = /*#__PURE__*/_createElementVNode(\"stop\", { \"stop-color\": \"#9249F5\" }, null, -1)\nconst _hoisted_6 = /*#__PURE__*/_createElementVNode(\"stop\", {\n  offset: \"0.484375\",\n  \"stop-color\": \"#4492D3\"\n}, null, -1)\nconst _hoisted_7 = /*#__PURE__*/_createElementVNode(\"stop\", {\n  offset: \"1\",\n  \"stop-color\": \"#06CAB8\"\n}, null, -1)\nconst _hoisted_8 = [\n  _hoisted_5,\n  _hoisted_6,\n  _hoisted_7\n]\nconst _hoisted_9 = /*#__PURE__*/_createElementVNode(\"clipPath\", { id: \"canvas\" }, [\n  /*#__PURE__*/_createElementVNode(\"rect\", {\n    width: \"96\",\n    height: \"96\",\n    fill: \"white\",\n    transform: \"translate(649.552)\"\n  })\n], -1)\n\n\nexport default /*#__PURE__*/_defineComponent({\n  __name: 'CanvasSvg',\n  props: {\n  simple: {\n    type: Boolean,\n    required: false,\n    default: false,\n  },\n},\n  setup(__props) {\n\n/* eslint-disable max-len */\n\n\nreturn (_ctx: any,_cache: any) => {\n  return (_openBlock(), _createElementBlock(\"svg\", {\n    xmlns: \"http://www.w3.org/2000/svg\",\n    viewBox: __props.simple ? '602 -42 192 192' : '0 0 746 96',\n    class: _normalizeClass({ 'w-[30px]': __props.simple,'w-[86px]' : !__props.simple })\n  }, [\n    (!__props.simple)\n      ? (_openBlock(), _createElementBlock(\"path\", _hoisted_2))\n      : _createCommentVNode(\"\", true),\n    _hoisted_3,\n    _createElementVNode(\"defs\", null, [\n      (!__props.simple)\n        ? (_openBlock(), _createElementBlock(\"linearGradient\", _hoisted_4, _hoisted_8))\n        : _createCommentVNode(\"\", true),\n      _hoisted_9\n    ])\n  ], 10, _hoisted_1))\n}\n}\n\n})"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "19c6c0b2cdbd326fad58635617f3610cabfe34e6"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1hcd01bec = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1hcd01bec();
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = (cov_1hcd01bec().s[0]++, ["viewBox"]);
const _hoisted_2 = (cov_1hcd01bec().s[1]++, {
  key: 0,
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M24.8222 20.1125C18.5075 23.3241 13.0416 27.9634 8.86501 33.6565L9.08508 33.3834C3.19544 41.2883 0.0134803 50.8585 0.00601086 60.6899C-0.102668 66.2234 1.26408 71.6871 3.96781 76.5276C6.48512 81.1552 10.3103 84.9517 14.9728 87.4502C20.0829 90.0247 25.7503 91.3185 31.4802 91.2185C39.6259 91.2697 47.6261 89.0767 54.5906 84.8834C61.6895 80.6791 67.4199 74.5366 71.0981 67.1888H53.5452C51.3499 70.4579 48.3598 73.1251 44.8512 74.9438C41.4485 76.6892 37.6765 77.6064 33.8463 77.6199C31.3636 77.7466 28.8813 77.3661 26.5529 76.5018C24.2245 75.6376 22.0998 74.308 20.3102 72.5955C18.6005 70.7772 17.2763 68.6365 16.4162 66.3005C15.556 63.9645 15.1774 61.4808 15.3029 58.9969C15.3655 57.1664 15.5494 55.3421 15.8532 53.5356C16.6123 48.9687 18.3376 44.6133 20.9155 40.7562C23.3529 37.2185 26.5951 34.2999 30.3797 32.2366C34.1255 30.2715 38.3035 29.2583 42.5402 29.2875C46.1519 29.1685 49.7224 30.0781 52.8298 31.9089C55.6078 33.6244 57.6914 36.2528 58.7175 39.3362H75.9403C75.529 35.8788 74.4264 32.5377 72.6973 29.5087C70.9682 26.4796 68.6474 23.8236 65.8708 21.6963C59.8501 17.2815 52.4966 15.0284 45.0163 15.3066C37.9921 15.2614 31.062 16.9107 24.8222 20.1125ZM131.045 76.7723H160.833L163.082 91.2239H178.882L165.331 15.2836H147.996L108.004 91.2239H123.694L131.045 76.7723ZM153.427 32.7482L158.913 64.8875H136.969L153.427 32.7482ZM285.475 91.2239H270.259L245.416 39.2207L236.231 91.2239H221.071L234.405 15.2836H249.51L274.464 67.4542L283.649 15.2836H298.699L285.475 91.2239ZM366.862 75.6893L356.965 15.2836H340.888L355.051 91.2239H373.151L413.453 15.2836H397.594L366.862 75.6893ZM489.881 76.7723H460.139L452.744 91.2239H437.079L477.064 15.2836H494.427L507.956 91.2239H492.181L489.881 76.7723ZM487.964 64.8875L482.486 32.7482L466.054 64.8875H487.964ZM551.951 80.0498C553.219 82.5335 555.107 84.6578 557.437 86.2223C562.956 89.7512 569.456 91.4885 576.025 91.1912C581.153 91.3069 586.246 90.3388 590.963 88.3518C594.941 86.7178 598.373 84.0119 600.866 80.5436C603.195 77.2073 604.414 73.2375 604.351 69.1862C604.476 65.6664 603.447 62.2007 601.419 59.3031C599.496 56.6071 597.005 54.3533 594.116 52.6961C590.759 50.7263 587.265 48.9929 583.66 47.5088C580.451 45.9799 577.962 44.7787 576.247 43.7958C574.602 42.9268 573.122 41.7812 571.876 40.4104C570.717 39.1372 570.086 37.4806 570.106 35.7692C570.061 34.5443 570.32 33.3273 570.86 32.2236C571.4 31.1198 572.205 30.1627 573.204 29.4352C575.59 27.7703 578.473 26.9435 581.392 27.0873C584.056 26.9267 586.688 27.7218 588.805 29.326C589.646 30.0286 590.316 30.9086 590.766 31.9009C591.216 32.8932 591.434 33.9725 591.405 35.0593V36.206H607.449C607.792 32.3987 606.922 28.5808 604.96 25.2854C602.868 21.9706 599.771 19.3911 596.108 17.914C591.741 16.074 587.024 15.1803 582.277 15.2931C577.337 15.2078 572.434 16.1569 567.893 18.0778C563.895 19.7058 560.457 22.4355 557.99 25.9406C555.536 29.4492 554.277 33.6371 554.394 37.8987C554.247 41.4564 555.234 44.97 557.215 47.9456C559.012 50.5121 561.377 52.6409 564.131 54.1704C567.526 56.0262 571.037 57.6675 574.642 59.0846C578.241 60.4662 581.689 62.2042 584.933 64.2719C585.958 64.9727 586.793 65.9124 587.362 67.0078C587.931 68.1032 588.218 69.3203 588.197 70.5513C588.262 71.8158 588.008 73.0765 587.458 74.2201C586.907 75.3638 586.078 76.3546 585.043 77.1036C582.466 78.7539 579.425 79.5567 576.357 79.3969C574.838 79.5082 573.312 79.3086 571.874 78.8106C570.437 78.3126 569.119 77.527 568.004 76.503C567.065 75.5434 566.359 74.3868 565.937 73.1198C565.516 71.8527 565.39 70.508 565.569 69.1862H550.189C550.131 70.1318 550.131 71.08 550.189 72.0256C550.077 74.8046 550.683 77.566 551.951 80.0498Z",
  fill: "url(#canvas-c)"
});
const _hoisted_3 = ( /*#__PURE__*/cov_1hcd01bec().s[2]++, _createStaticVNode("<g clip-path=\"url(#canvas)\"><path d=\"M667.927 77.625H649.552V96H667.927V77.625Z\" fill=\"#4492D3\"></path><path d=\"M745.552 0H727.177V18.375H745.552V0Z\" fill=\"#4492D3\"></path><path d=\"M745.552 18.375H727.177V77.625H667.927V96H745.552V18.375Z\" fill=\"#06CAB8\"></path><path d=\"M667.927 77.625H649.552V38.8125L688.365 0H727.177V18.375H695.865L667.927 46.3125V77.625Z\" fill=\"#9249F5\"></path></g>", 1));
const _hoisted_4 = (cov_1hcd01bec().s[3]++, {
  key: 0,
  id: "canvas-c",
  x1: "-4.20925",
  y1: "53.2967",
  x2: "607.726",
  y2: "53.2967",
  gradientUnits: "userSpaceOnUse"
});
const _hoisted_5 = ( /*#__PURE__*/cov_1hcd01bec().s[4]++, _createElementVNode("stop", {
  "stop-color": "#9249F5"
}, null, -1));
const _hoisted_6 = ( /*#__PURE__*/cov_1hcd01bec().s[5]++, _createElementVNode("stop", {
  offset: "0.484375",
  "stop-color": "#4492D3"
}, null, -1));
const _hoisted_7 = ( /*#__PURE__*/cov_1hcd01bec().s[6]++, _createElementVNode("stop", {
  offset: "1",
  "stop-color": "#06CAB8"
}, null, -1));
const _hoisted_8 = (cov_1hcd01bec().s[7]++, [_hoisted_5, _hoisted_6, _hoisted_7]);
const _hoisted_9 = ( /*#__PURE__*/cov_1hcd01bec().s[8]++, _createElementVNode("clipPath", {
  id: "canvas"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "96",
  height: "96",
  fill: "white",
  transform: "translate(649.552)"
})], -1));
export default /*#__PURE__*/_defineComponent({
  __name: 'CanvasSvg',
  props: {
    simple: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(__props) {
    cov_1hcd01bec().f[0]++;
    cov_1hcd01bec().s[9]++;
    /* eslint-disable max-len */
    return (_ctx, _cache) => {
      cov_1hcd01bec().f[1]++;
      cov_1hcd01bec().s[10]++;
      return _openBlock(), _createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: __props.simple ? (cov_1hcd01bec().b[0][0]++, '602 -42 192 192') : (cov_1hcd01bec().b[0][1]++, '0 0 746 96'),
        class: _normalizeClass({
          'w-[30px]': __props.simple,
          'w-[86px]': !__props.simple
        })
      }, [!__props.simple ? (cov_1hcd01bec().b[1][0]++, (_openBlock(), _createElementBlock("path", _hoisted_2))) : (cov_1hcd01bec().b[1][1]++, _createCommentVNode("", true)), _hoisted_3, _createElementVNode("defs", null, [!__props.simple ? (cov_1hcd01bec().b[2][0]++, (_openBlock(), _createElementBlock("linearGradient", _hoisted_4, _hoisted_8))) : (cov_1hcd01bec().b[2][1]++, _createCommentVNode("", true)), _hoisted_9])], 10, _hoisted_1);
    };
  }
});